import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import './index.scss';
import App from './App';
import { USERBACK_ACCESS_TOKEN } from './constants/constants';
import { Provider } from 'react-redux';
import { store } from './redux/_store/configureStore';
import { WalletKeys } from './services/parrentApp.service';
import BigNumber from 'bignumber.js';
import { BrowserRouter } from 'react-router-dom';

// import { SocketManager } from '@ultrade/ultrade-js-sdk';
// import { generateTxnForSign } from '@ultrade/shared/browser/common/auth.helper';
// // import ClientSDK from "@ultrade/react-sdk"

// // console.log('ClientSDK', ClientSDK);
// console.log('SocketManager', SocketManager);
// console.log('auth.helper', generateTxnForSign);

declare global {
  interface Window {
    Userback: any;
    Cypress: any;
    store: any;
    io: any;
    OrderActions: any;
    providers: any;
    Ultrade: {
      [key in WalletKeys]?: (tx: any) => any;
    };
    isWalletInheritance: boolean;
    TelegramLoginWidget: any;
    ethereum: any //TODO ADD TYPES
  }
}

// const originalConsoleLog = console.log;


// console.log = function(...args) {
//   const message = args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : arg).join(' ');
//   originalConsoleLog.apply(console, args);

//   fetch(API_HOST + '/market/fe-logs', {
//       method: 'POST',
//       headers: {
//           'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({log: message, timestamp: new Date()}),
//   }).catch(error => originalConsoleLog('Error logging to backend:', error));
// };


BigNumber.config({
  DECIMAL_PLACES: 18,
  EXPONENTIAL_AT: 45,
  FORMAT: {
    decimalSeparator: ".",
    groupSeparator: ",",
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: " ",
    fractionGroupSize: 0,
  },
});

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: [
      'ar',
      'de',
      'en',
      'es',
      'fr',
      'hi',
      'id',
      'ko',
      'pt',
      'pl',
      'ru',
      'th',
      'tr',
      'xl',
      'zh',
    ],
    fallbackLng: 'en',
    detection: {
      order: ['cookie', 'htmlTag', 'localStorage', 'path', 'subdomain'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/assets/langs/{{lng}}/translation.json',
      requestOptions: {
        cache: 'no-store',
      },
    },
    react: { useSuspense: true },
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

const Index = () => {
  return (
    <Suspense>
      <React.StrictMode>
        <BrowserRouter>
          <Provider store={store}>
              <App />
          </Provider>
        </BrowserRouter>
      </React.StrictMode>
    </Suspense>
  );
};

root.render(<Index />);

if (USERBACK_ACCESS_TOKEN) {
  window.Userback = window.Userback || {};
  window.Userback.access_token = USERBACK_ACCESS_TOKEN;
  var s = document.createElement('script');
  s.async = true;
  s.src = 'https://static.userback.io/widget/v1.js';
  (document.head || document.body).appendChild(s);
}
